import AppDataService from "./AppDataService";

export default class ContactDirectoryService {
  static async postContactDirectoryData(data) {
    return await AppDataService.post("contact-directory", data); // Corrected syntax with string
  }

  static async getContactDirectoryList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.searchKey ? `searchKey=${data.searchKey}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`contact-directory${queryString}`);
  }

  static async updateContactData(id, data) {
    return await AppDataService.patch(`contact-directory/${id}`, data); // Corrected syntax with string
  }

  static async deleteContact(id) {
    return await AppDataService.delete(`contact-directory/${id}`);
  }
}
